import React, { Fragment, useState, useEffect } from "react";
import {
    Card,
    CardBody,
    CardFooter,
    CardHeader,
    CardTitle,
    Label,
    Nav,
    NavItem,
    NavLink,
} from "reactstrap";
import { useLocation, useNavigate } from "react-router-dom";
import classnames from "classnames";
import { H4 } from "../../../AbstractElements";
import ClincIncome from "./AccountsTab/ClinicIncome";
import PharmacyIncome from "./AccountsTab/PharmacyIncome";
import NetValue from "./AccountsTab/NetValue";
import PharmancyExpense from "./ExpenseTab/PharmacyExpense";
import InventoryExpense from "./ExpenseTab/InventoryExpense";
import LabPayment from "./ExpenseTab/LabPayment";
import ConsultantExpense from "./ExpenseTab/ConsultantExpense";
import Salary from "./ExpenseTab/Salary";
import Others from "./ExpenseTab/Others";
import { roles_permissions } from "../../../Layout/Sidebar/Menu";


const Accounts = () => {
    const [currentTab, setCurrentTab] = useState("summary");
    const location = useLocation();
    const navigate = useNavigate();


    const tabs = ["Patient-Clinic-Income", "Pharmacy-Income", "Net-Profit"];
    const tabs_expense = [
        "Pharmacy-Expense",
        "Inventory-Expense",
        "Lab-Payment",
        "Consultant-Expense",
        "Salary",
        "Others",
    ];

    const permissionsMapping = {
        'Patient-Clinic-Income': 'Patient Clinic Income',
        "Pharmacy-Income": 'Pharmacy Income',
        "Net-Profit": 'Net Profit'
    }

    const expenseMapping  = {
        "Pharmacy-Expense": 'Pharmacy Expense',
        "Inventory-Expense": 'Inventory Expense',
        "Lab-Payment": 'Lab Payment',
        "Consultant-Expense": 'Consultant Expense',
        "Salary": "Salary",
        "Others": 'Other',
    }

    const filteredTabs = tabs.filter((tab) => {
        const permission = roles_permissions.find(
          (role) => role.module_name === permissionsMapping[tab]
        );
        return permission?.view_access;
      });

    const filteredExpenseTabs = tabs_expense.filter((tab) => {
        const permission = roles_permissions.find(
          (role) => role.module_name === expenseMapping[tab]
        );
        return permission?.view_access;
      });

    useEffect(() => {
        const tab = location.pathname.split("/").pop();
        setCurrentTab(tab);
    }, [location]);

    // const handleTabChange = (tab) => {
    //   const path = `/patient/${tab}`;
    //   if (path !== location.pathname) {
    //     navigate(path);
    //     setCurrentTab(tab);
    //   }
    // };

    const handleTabChange = (tab) => {
        navigate(`/accounts/${tab}`);
        setCurrentTab(tab);
    };

    const renderTabContent = () => {

        const permission = roles_permissions.find(
            (role) => role.module_name === expenseMapping[currentTab]
          );
        switch (currentTab) {
            case "Patient-Clinic-Income":
                return (
                    <div>
                        <ClincIncome />
                    </div>
                );
            case "Pharmacy-Income":
                return (
                    <div>
                        {" "}
                        <PharmacyIncome />
                    </div>
                );
            case "Net-Profit":
                return (
                    <div>
                        <NetValue />
                    </div>
                );
            case "Pharmacy-Expense":
                return (
                    <div>
                        <PharmancyExpense permission={permission} />
                    </div>
                );
            case "Inventory-Expense":
                return (
                    <div>
                        {" "}
                        <InventoryExpense permission={permission}/>
                    </div>
                );
            case "Lab-Payment":
                return (
                    <div>
                        {" "}
                        <LabPayment  permission={permission}/>
                    </div>
                );
            case "Consultant-Expense":
                return (
                    <div>
                        <ConsultantExpense permission={permission}/>
                    </div>
                );
            case "Salary":
                return (
                    <div>
                        {" "}
                        <Salary permission={permission} />
                    </div>
                );
            case "Others":
                return (
                    <div>
                        {" "}
                        <Others permission={permission} />
                    </div>
                );
            default:
                return null;
        }
    };
    //   const handleTabClick = (tab) => {
    //     onTabChange(tab);
    //   };

    return (
        <Fragment>
            <Card>
                <CardHeader>
                    <H4>Income</H4>
                </CardHeader>
                <CardHeader>
                    <Nav pills justified>
                        {filteredTabs.map((tab) => (
                            <NavItem key={tab} style={{ cursor: "pointer" }}>
                                <NavLink
                                    className={classnames("tab-link", {
                                        "active-tab": currentTab === tab,
                                    })}
                                    // className={classnames({ active: currentTab === tab })}
                                    onClick={() => handleTabChange(tab)}
                                >
                                    {tab.replace(/-/g, " ").toUpperCase()}
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                </CardHeader>
                <CardHeader>
                    <H4>Expense</H4>
                </CardHeader>
                <CardHeader>
                    <Nav pills justified>
                        {filteredExpenseTabs.map((tab) => (
                            <NavItem key={tab} style={{ cursor: "pointer" }}>
                                <NavLink
                                    className={classnames("tab-link", {
                                        "active-tab": currentTab === tab,
                                    })}
                                    // className={classnames({ active: currentTab === tab })}
                                    onClick={() => handleTabChange(tab)}
                                >
                                    {tab.replace(/-/g, " ").toUpperCase()}
                                </NavLink>
                            </NavItem>
                        ))}
                    </Nav>
                </CardHeader>
                <CardBody>
                    <div className="container-fluid mt-5">
                        <Card>{renderTabContent()}</Card>
                    </div>
                </CardBody>
            </Card>
        </Fragment>
    );
};

export default Accounts;
